export default __webpack_public_path__ + "static/media/Data Arranging.c95f6d34.svg";